import { GET_HNIR_REQUEST,
    GET_HNIR_SUCCESS,
    GET_HNIR_FAILURE, } from "./constants";

export interface IState {
    startDate: Date;
    stopDate: Date;
    gotData: boolean;
    loading: boolean;
    error: null | string;
    data: any;
}

export const initialState: any = {
    gotData: false,
    loading: false,
    error: null,
    startDate: new Date(),
    stopDate: new Date(),
    datap2: 0,
    scoreData: [],
};

export const HNIRReducer = (state: any = initialState, action: any) => {
    switch (action.type) {
        case GET_HNIR_REQUEST:
            return {
                ...state,
                gotData: false,
                loading: true,
                error: null,
            };
        case GET_HNIR_SUCCESS:

            const newState = {
                ...state,
                loading: false,
                gotData: true,
                datap2: action.payload.datap2,
                scoreData: action.payload.scoreData,
            };
            return newState;

        case GET_HNIR_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};
